#import "../../../../../../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query TripSecureRowLevels {
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
